import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Checkbox,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";

const titles = ["Clientes"];

const useStyles = makeStyles({
  tableContainer: {
    maxHeight: window.screen.height - 350,
    overflow: "auto",
  },
});

const HeaderTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontSize: 14,
  },
}))(TableCell);

function CustomersTable(props) {
  const { customers, selectedCustomers, setSelectedCustomers } = props;
  const classes = useStyles();

  const handleCheckChange = (value) => {
    const currentIndex = selectedCustomers.indexOf(value);
    const newChecked = [...selectedCustomers];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedCustomers(newChecked);
  };

  const handleCheckAllRows = () => {
    if (customers.length === selectedCustomers.length) {
      setSelectedCustomers([]);
    } else {
      setSelectedCustomers(customers);
    }
  };

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <Table stickyHeader>
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <HeaderTableCell padding="checkbox">
              <Checkbox
                checked={
                  customers.length === selectedCustomers.length &&
                  customers.length > 0
                }
                onChange={handleCheckAllRows}
              />
            </HeaderTableCell>
            {titles.map((title, index) => (
              <HeaderTableCell key={index} align="left">
                {title}
              </HeaderTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {customers.map((customer) => (
            <TableRow key={customer.id}>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectedCustomers.includes(customer)}
                  onChange={() => handleCheckChange(customer)}
                />
              </TableCell>
              <TableCell align="left">{customer.nameAndSurname}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
export default CustomersTable;
